import React, { useEffect, useState } from "react";
import {
  getWishlist,
  removeFromWishlist
} from "../../services/wishlistApi";

import "./WishlistPage.css";

const WishlistPage = () => {
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);

  // ======================
  // LOAD WISHLIST
  // ======================
  const fetchWishlist = async () => {
    try {
      const res = await getWishlist();
      setWishlist(res.wishlist || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWishlist();
  }, []);

  // ======================
  // REMOVE ITEM
  // ======================
  const handleRemove = async (productId) => {
    try {
      await removeFromWishlist(productId);
      setWishlist((prev) =>
        prev.filter((item) => item.id !== productId)
      );
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) {
    return (
      <div className="wishlist-page">
        <div className="wishlist-loading">
          <div className="wishlist-spinner"></div>
          <p>Loading wishlist...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="wishlist-page">
      <div className="wishlist-container">

        {/* ======================
            HEADER
        ====================== */}
        <div className="wishlist-header">
          <div>
            <h2>My Wishlist ❤️</h2>
            <p>
              {wishlist.length}{" "}
              {wishlist.length === 1 ? "item" : "items"}
            </p>
          </div>
        </div>

        {/* ======================
            EMPTY WISHLIST
        ====================== */}
        {wishlist.length === 0 ? (
          <div className="wishlist-empty">
            <div className="empty-icon">❤️</div>

            <h3>Your wishlist is empty</h3>

            <p>
              You haven't added any products to your wishlist yet.
            </p>
          </div>
        ) : (
          /* ======================
             WISHLIST ITEMS
          ====================== */
          <div className="wishlist-list">
            {wishlist.map((item) => (
              <div
                className="wishlist-item"
                key={item.id}
              >
                {/* PRODUCT INFO */}
                <div className="wishlist-item-info">
                  <div className="wishlist-product-icon">
                    ❤️
                  </div>

                  <div className="wishlist-product-details">
                    <h4>{item.name}</h4>

                    <p className="wishlist-price">
                      ₹{item.price}
                    </p>
                  </div>
                </div>

                {/* REMOVE BUTTON */}
                <button
                  className="wishlist-remove-btn"
                  onClick={() => handleRemove(item.id)}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
};

export default WishlistPage;
